import { authRoutes, router } from '.././router'
import { type QrErrorCode } from '../state'
import { postGetBody, type ProblemDetailsResponse } from '@webapp2/shared/services/api'
import { authenticated, type AuthenticatedResponse } from './authentication-service'

export async function qrLogin(qrCode: string) {
  const parts = qrCode.split(':')
  if (parts.length !== 2) {
    await setError('Invalid')
    return
  }
  const token = parts[1]
  const response = await postGetBody<AuthenticatedResponse | ProblemDetailsResponse>('login-qr-token', { token })
  if (response && 'user' in response) {
    await router.push(await authenticated(response, 'qr', response.redirectPath ?? undefined))
  } else {
    await setError(response ? (response.title as QrErrorCode) : 'Invalid')
  }
}

async function setError(qrErrorCode: QrErrorCode) {
  await router.push({ name: authRoutes.login.name, state: { qrErrorCode } })
}
